import { EventEmitter } from 'events';
export function createInterface(options) {
    var emitter = new EventEmitter();
    options.input.on('data', function (data) {
        emitter.emit('line', data);
    });
    return emitter;
}
